import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Customers from "./Customers";
import CustVehicleDetails from "./CustVehicleDetails";

class CustomerRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/customer" component={Customers} />
        <Route exact path="/customer/vehicle/:id" component={CustVehicleDetails} />
      </Switch>
    );
  }
}

export default CustomerRoutes;



// WEBPACK FOOTER //
// ./src/admin/customer/CustomerRoutes.js